import { csrfToken } from "./rails"

export function contextOverviewFromPayload(payload = {}) {
  if (!payload || typeof payload !== "object") return null

  return payload.contextOverview || payload.context_overview || null
}

export function contextTimestampFromPayload(payload = {}, fallback = null) {
  if (!payload || typeof payload !== "object") return fallback

  return payload.lastUpdatedAt || payload.completedAt || payload.completed_at || fallback
}

export function conceptContextEvidenceSignature(context = {}) {
  const users = Array.isArray(context?.users) ? context.users : []

  return JSON.stringify(users.map((user = {}) => ({
    key: user.key || null,
    name: user.name || null,
    archetype: user.archetype || null,
    headlineQuote: user.headlineQuote || user.headline_quote || user.quote || null,
    role: user.role || null,
    goals: normalizedList(user.goals),
    primaryGoal: user.primaryGoal || user.primary_goal || null,
    secondaryGoals: normalizedList(user.secondaryGoals || user.secondary_goals),
    careAbouts: normalizedList(user.careAbouts || user.care_abouts),
    topIssues: normalizedList(user.topIssues || user.top_issues),
    painPoints: normalizedList(user.painPoints || user.pain_points),
    constraints: normalizedList(user.constraints),
    criticalNeeds: normalizedList(user.criticalNeeds || user.critical_needs),
    decisionCriteria: normalizedList(user.decisionCriteria || user.decision_criteria),
    relationships: normalizedRelationships(user.relationships)
  })))
}

export function patchRepositoryContext(updatePath, repositoryContext, fallbackError = "Could not save context.") {
  return fetch(updatePath, {
    method: "PATCH",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      "X-CSRF-Token": csrfToken()
    },
    body: JSON.stringify({
      repository_context: repositoryContext
    })
  })
    .then((response) => (
      response.json()
        .catch(() => ({}))
        .then((payload) => {
          const errorMessage = payload && typeof payload === "object" ? payload.error : null
          if (!response.ok) throw new Error(errorMessage || fallbackError)

          return payload
        })
    ))
}

function normalizedList(value) {
  return Array.isArray(value) ? value.map((item) => String(item || "").trim()).filter(Boolean) : []
}

function normalizedRelationships(value) {
  return Array.isArray(value)
    ? value.map((relationship = {}) => ({
      personaKey: relationship.personaKey || relationship.persona_key || null,
      label: relationship.label || relationship.name || null,
      relationship: relationship.relationship || relationship.role || null,
      sharedGoal: relationship.sharedGoal || relationship.shared_goal || null,
      tension: relationship.tension || null
    }))
    : []
}
